<script lang="ts">
	import { goto } from '$app/navigation';
	import { forceLogin } from '$lib/service/WalletManager';
	import { logoutSession, session } from '$lib/stores/userstore';
	import { createEventDispatcher } from 'svelte';
	import Button from '../button/Button.svelte';
	import { CloseIcon } from '../icons';
	import DisplayIcon from '../icons/DisplayIcon.svelte';
	import Overlay from '../loading/Overlay.svelte';
	import FontSpan from '../typography/FontSpan.svelte';

	const dispatchClose = createEventDispatcher<{ closed: { closed: boolean } }>();

	export let protectedPage = false;
	let open = false;

	$: open = !!$session && $session.expired;

	function toggle() {
		open = !open;
		if (!open) {
			dispatchClose('closed', { closed: true });
		}
	}

	function handleKeydown(event: KeyboardEvent) {
		if (event.key === 'Escape') {
			event.preventDefault();
			event.stopPropagation();
			open = false;
			dispatchClose('closed', { closed: true });
		}
	}

	let depositeInprogress = false;
	async function reloadHandler() {
		await forceLogin();
		open = false;
		if ($session) {
			$session.expired = false;
		}
		dispatchClose('closed', { closed: true });
	}
	async function continueHandler() {
		if (protectedPage) {
			goto('/');
			logoutSession();
		}
	}
</script>

<svelte:window on:keydown={handleKeydown} />

<Overlay show={depositeInprogress} />
<div
	class="modal fixed w-full h-full top-0 left-0 flex items-center justify-center z-40"
	class:opacity-0={!open}
	class:pointer-events-none={!open}
>
	<div class="modal-overlay absolute w-full h-full" />

	<div class="modal-container z-50">
		<div
			role="button"
			tabindex="0"
			on:click={() => toggle()}
			on:keypress={handleKeydown}
			class="modal-close absolute top-0 right-0 cursor-pointer flex flex-col items-center mt-4 mr-4 text-white text-sm z-50"
		>
			<DisplayIcon size={18} icon={CloseIcon} css="fill-current text-white" />
			<span class="text-sm">(Esc)</span>
		</div>
		<div class="modal-content relative text-left">
			<div class="modal-header">
				<div class="model-title-container">
					<div class="flex">
						<FontSpan varient="body-B-03" class="text-white">Session Expired</FontSpan>
					</div>
				</div>
			</div>
			<!--Body-->
			<div class="flex flex-col modal-body justify-center grow w-full items-center">
				<FontSpan varient="body-R-03" class="text-white p-2 mt-4">
					Do you want to relogin or continue as anonymous?
				</FontSpan>
				<div class="flex mt-2 gap-4">
					<Button type="secondary" class="p-2 text-white" text="Relogin" on:click={reloadHandler} />
					<Button
						type="secondary"
						class="p-2 text-white"
						text="Continue"
						on:click={continueHandler}
					/>
				</div>
			</div>
		</div>
	</div>
</div>

<style>
	.modal-body {
		padding: 10px 11px 10px 10px;
		gap: 10px;
	}
	.model-title-container {
		display: flex;
		width: 401px;
		height: 39px;
		padding: 0px 32px 2px 0px;
		justify-content: center;
		align-items: flex-start;
		gap: 12px;
	}
	.modal-header {
		display: flex;
		height: 39px;
		padding: 0px 16px;
		justify-content: center;
		align-items: flex-start;
		gap: 13px;
		flex-shrink: 0;
		align-self: stretch;
	}
	.modal-container {
		display: flex;
		padding: 12px;
		flex-direction: column;
		align-items: center;
		gap: 40px;

		border-radius: 30px;
		border: 1px solid var(--popup-border, #2d2d2d);
		background: var(--bg, #151516);

		/* popup_shadow */
		box-shadow: 0px 0px 20px 0px rgba(189, 189, 189, 0.2);
	}
	.modal-overlay {
		background: rgba(0, 0, 0, 0.8);
		backdrop-filter: blur(8px);
	}

	.modal {
		transition: opacity 0.25s ease;
	}
</style>
